/* sdx-cart-page — re-render line items after qty/remove via Section Rendering API */
(function () {
  'use strict';

  function findSectionId() {
    const el = document.querySelector('[data-sdx-cart-page]');
    if (!el) return null;
    const match = el.id && el.id.match(/^sdx-cart-(.+)$/);
    return match ? match[1] : null;
  }

  async function refreshCartPage() {
    const id = findSectionId();
    if (!id) { window.location.reload(); return; }
    try {
      const res = await fetch(`${window.location.pathname}?sections=${id}`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const data = await res.json();
      const html = data[id];
      if (!html) { window.location.reload(); return; }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newSection = parsed.querySelector(`#sdx-cart-${id}`);
      const currentSection = document.querySelector(`#sdx-cart-${id}`);
      if (newSection && currentSection) {
        currentSection.replaceWith(newSection);
      } else {
        window.location.reload();
      }
    } catch (err) {
      window.location.reload();
    }
  }

  // Listen to cart changes dispatched by sdx-cart.js
  document.addEventListener('cart:change', (e) => {
    if (document.querySelector('[data-sdx-cart-page]')) {
      refreshCartPage();
    }
  });
})();
